import { render, staticRenderFns } from "./StaffPositionSelect.vue?vue&type=template&id=e961441e&scoped=true&"
import script from "./StaffPositionSelect.vue?vue&type=script&lang=ts&"
export * from "./StaffPositionSelect.vue?vue&type=script&lang=ts&"
import style0 from "./StaffPositionSelect.vue?vue&type=style&index=0&id=e961441e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e961441e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
